// extracted by mini-css-extract-plugin
module.exports = {"wn1j5xj":"wn1j5xj","pi40lrf":"pi40lrf","tgqp2fj":"tgqp2fj","d66f43p":"d66f43p","h15tjzrj":"h15tjzrj"};